import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64c937a8")

_pushScopeId("data-v-64c937a8")
const _hoisted_1 = { class: "ui__checkPosition" }
const _hoisted_2 = { class: "ui__checkPosition_title_count" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "checkPositionCont_box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkPositionCont = _resolveComponent("checkPositionCont")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode("div", {
      class: "ui__checkPosition_title",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeChildrenShow && _ctx.changeChildrenShow(...args)))
    }, [
      _createVNode("span", null, _toDisplayString(_ctx.carPositionRenderData.areaName), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", null, [
          _createVNode("img", {
            src: require('@/assets/toc/ok1.png'),
            alt: ""
          }, null, 8, ["src"]),
          _createTextVNode(" " + _toDisplayString(_ctx.carPositionRenderData.itemCount-_ctx.carPositionRenderData.defectItemCount) + "项 ", 1)
        ]),
        (_ctx.carPositionRenderData.defectItemCount>0)
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode("img", {
                src: require('@/assets/toc/warn1.png'),
                alt: ""
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.carPositionRenderData.defectItemCount) + "项 ", 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("img", {
          src: require('@/assets/toc/arrowDown.png'),
          alt: ""
        }, null, 8, ["src"])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carPositionRenderData.itemList, (item) => {
        return _withDirectives((_openBlock(), _createBlock(_component_checkPositionCont, {
          key: `${_ctx.carPositionRenderKey}${item.checkItemCode}`,
          checkPositionContRenderData: item,
          checkPositionContRenderKey: `${_ctx.carPositionRenderKey}${item.checkItemCode}`
        }, null, 8, ["checkPositionContRenderData", "checkPositionContRenderKey"])), [
          [_vShow, !_ctx.state.tocOnlyShowFlaw || (_ctx.state.tocOnlyShowFlaw && item.unusual)]
        ])
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.showChildrenStatus]
    ])
  ]))
})